import { createFileRoute, notFound } from '@tanstack/react-router';

import { DetailsNavigationBar } from '@/features/agents';
import { getAgentOptions, toAgentId } from '@/hooks/api';

export const Route = createFileRoute('/_auth/_org/details/agents/$agentId')({
  loader: async ({ context: { client, queryClient }, params: { agentId } }) => {
    const agent = await queryClient.ensureQueryData(getAgentOptions(client, queryClient, toAgentId(agentId)));
    if (!agent) throw notFound();
    return { agent };
  },
  component: DetailsNavigationBar,
  notFoundComponent: () => {
    return <p>Agent not found!</p>;
  },
});
